module.exports = __webpack_public_path__ + "img/fa-7@3x.7e6c93c9.png";